import { ProcedureDefinition } from "../types";
import { CraneActionKey } from "./keys";

export enum ProcedureKey {
  LIFTING = "LIFTING",
  PERSONNEL = "PERSONNEL",
  PARKING = "PARKING",
  MAINTENANCE = "MAINTENANCE",
}

// Simple procedure definitions
export const procedures: Record<string, ProcedureDefinition> = {
  [ProcedureKey.LIFTING]: {
    id: "lifting",
    name: "Lifting operation",
    description: "Standard cargo and heavy lift operations",
    actions: [
      CraneActionKey.BOOMING_UP,
      CraneActionKey.BOOMING_DOWN,
      CraneActionKey.HOISTING_UP,
      CraneActionKey.HOISTING_DOWN,
      CraneActionKey.SLEWING_LEFT,
      CraneActionKey.SLEWING_RIGHT,
      CraneActionKey.TUGGER_IN,
      CraneActionKey.TUGGER_OUT,
    ],
  },

  [ProcedureKey.PERSONNEL]: {
    id: "personnel",
    name: "Personnel lifting",
    description: "Transfer of people with stricter safety limits",
    actions: [
      CraneActionKey.PERSONNEL_LIFT,
      CraneActionKey.HOISTING_DOWN,
      CraneActionKey.HOISTING_UP,
    ],
  },

  [ProcedureKey.PARKING]: {
    id: "parking",
    name: "Parking",
    description: "Boom and hook secured for stowage",
    actions: [],
  },

  [ProcedureKey.MAINTENANCE]: {
    id: "maintenance",
    name: "Maintenance",
    description: "Testing and servicing with safety controls",
    actions: [],
  },
};
